import React, { useRef, useState } from "react";
import { colors, fonts, mediaQueriesNumbers, useMediaQuery, frames, glyphs, css } from "../../Styles";
import { NewInput, NewModal, MainContentPaddingTypes } from "..";
import { ButtonTypes, NewInputHandles } from "../../Definitions";
import { useTranslation } from "react-i18next";
import { useUser } from "../../Services"
import NewButton from "../BaseComponents/Buttons/newButton";

interface forgotPwdProps {
  ifSucces: () => void
  onGoBack: () => void
}

export default function ForgotPasswordModal({ifSucces, onGoBack}:forgotPwdProps) {
  const {t} = useTranslation()
  const {createUserResetToken} = useUser();
  const inputRef = useRef<NewInputHandles>(null); 
  const [message, setMessage] = useState<string|null>(null)

  // Use "Enter" to submit
  onkeydown = (event) => {
    if (event.code === "Enter") {
      ForgotPasswordAction()
    }
  }

  const ForgotPasswordAction = () => {
    const Username = inputRef.current?.value;
    if (!Username) {
      inputRef.current?.setError();
      setMessage(t("loginFlow.forgotPassword.usernameRequired", {defaultValue: "user Name Required"}))
    } else {
      createUserResetToken(Username.toString()).then(success => {
        if (success) 
          ifSucces()
        else setMessage(t("loginFlow.forgotPassword.noUsernameFound", {defaultValue: "username does not excist"}))
      })
    }
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  return (
      <frames.DecorBg>      
        <NewModal 
          modalState
          header={t("loginFlow.login.forgotPassword", {defaultValue: "Forgot Password"})} 
          overrides={{ 
            mainContentPadding: MainContentPaddingTypes.secondary,
            overlayColor: colors.blackPrimary + "99",
            footerMessageTopOffset: "65px"
          }}
          predefinedButtons={{
            onGoBack: onGoBack 
          }}
          mainContent={            
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", width: "100%"}}>
              {/* If no email, contact support. */}
              <p style={{ ...fonts.paragraph, ...fonts.textShadow, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "280px" }}>
                {t("loginFlow.forgotPassword.text", {defaultValue: "Text not found"})}
              </p>
              {/* Don't close the window. */}
              <p style={{ ...fonts.paragraph, ...fonts.textShadow, ...fonts.fontSize3, color: colors.greyLightTertiary, textAlign: "center", whiteSpace: 'pre-wrap', maxWidth: "280px" }}>
                {t("loginFlow.forgotPassword.text2", {defaultValue: "Text not found"})}
              </p>
              <NewInput ref={inputRef}
                placeholder={t("user.userName", {defaultValue: "User Name"})}
                startEnhancer={glyphs.User({})}
                valueOverrides={{
                  valueType: "string"
                }}
              />
              {/* Reset password button */}
              <NewButton content={t("loginFlow.login.resetPassword", {defaultValue: "Reset Password"})} onClick={ForgotPasswordAction}
                buttonType={ButtonTypes.primaryButton}
              />
            </div>
          }
        footerContent={
          <div style={{display: "flex", alignItems: "center", flexDirection: "column", gap: "5px"}}>
            <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center" }}>{`${t("loginFlow.forgotPassword.noEmail", {defaultValue: "No email assigned"})}?`}</p>
            <NewButton
              content={t("loginFlow.forgotPassword.contactSupport", {defaultValue: "Contact Support"})}
              onClick={() => window.location.href = 'mailto:support@agrisys.dk'}
              buttonType={ButtonTypes.textButton}
              overrides={{
                baseStyles: {...css.button_TextUnderline}
              }}
            />
            <p style={{ ...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary, textAlign: "center", marginTop: "2px" }}>support@agrisys.dk</p>
          </div>
          }
        footerMessage={message ?? ""}
        />
      </frames.DecorBg>
    )
}